import React from 'react';
import {MasterLayout} from 'components/layouts';
import {Business} from 'components/business/business-page';
import title from 'constants/TitlePages.js';

class BusinessPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  componentDidMount() {
    document.title = title.BusinessPage;
  }

  render() {
    return (
      <MasterLayout>
        <Business params={this.props.match.params}/>
      </MasterLayout>
    );
  }
}

export default BusinessPage;



// WEBPACK FOOTER //
// ./pages/businesses/BusinessPage.jsx